import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter, DateTimeFormatter} from "../../../utils/formatters";

class shippingorderList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "shippingorderList"}
                {...props}
                columns={{
                    [componentConfig.idfield]: {header: 'kód', width: 1, sortable, filterable},
                    "tracking_id": {header: 'Követési kód', width: 1, sortable, filterable},
                    "partner.name": {header: 'Megrendelő', width: 2, sortable, filterable},
                    "destination": {header: 'Címzett', width: 2},
                    "order_date": {header: 'Rendelés időpontja', width: 2, sortable, filterable, renderer: DateTimeFormatter}
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default shippingorderList;
